export default __webpack_public_path__ + "static/media/Elixir of Invigorative Rejuvenation.af9e7feb.jpg";